var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('picture',{class:{ 'hidden' : !_vm.exibirMobile}},[_c('source',{attrs:{"data-srcset":_vm.image.src,"type":`image/${_vm.image.fileType}`}}),_c('img',{class:{lazyload: _vm.lazyload},style:({maxWidth : `${_vm.actualSize}px`}),attrs:{"title":_vm.label,"alt":_vm.label,"src":_vm.image.src,"width":_vm.width,"height":_vm.height}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }